import { render, staticRenderFns } from "./VaultFeesRow.vue?vue&type=template&id=5ef0ae5b&"
import script from "./VaultFeesRow.vue?vue&type=script&lang=js&"
export * from "./VaultFeesRow.vue?vue&type=script&lang=js&"
import style0 from "./VaultFeesRow.vue?vue&type=style&index=0&id=5ef0ae5b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports